import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as dom from '../../../base/browser/dom.js';
import { LinkedList } from '../../../base/common/linkedList.js';
import { parse } from '../../../base/common/marshalling.js';
import { Schemas } from '../../../base/common/network.js';
import { normalizePath } from '../../../base/common/resources.js';
import { URI } from '../../../base/common/uri.js';
import { ICodeEditorService } from './codeEditorService.js';
import { ICommandService } from '../../../platform/commands/common/commands.js';
import { matchesScheme } from '../../../platform/opener/common/opener.js';
import { EditorOpenContext } from '../../../platform/editor/common/editor.js';

var CommandOpener = /*#__PURE__*/function () {
  function CommandOpener(_commandService) {
    _classCallCheck(this, CommandOpener);

    this._commandService = _commandService;
  }

  _createClass(CommandOpener, [{
    key: "open",
    value: function open(target) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$_commandService;

        var args;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (matchesScheme(target, Schemas.command)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                // run command or bail out if command isn't known
                if (typeof target === 'string') {
                  target = URI.parse(target);
                } // execute as command


                args = [];

                try {
                  args = parse(decodeURIComponent(target.query));
                } catch (_a) {
                  // ignore and retry
                  try {
                    args = parse(target.query);
                  } catch (_b) {// ignore error
                  }
                }

                if (!Array.isArray(args)) {
                  args = [args];
                }

                _context.next = 8;
                return (_this$_commandService = this._commandService).executeCommand.apply(_this$_commandService, [target.path].concat(_toConsumableArray(args)));

              case 8:
                return _context.abrupt("return", true);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return CommandOpener;
}();

CommandOpener = __decorate([__param(0, ICommandService)], CommandOpener);

var EditorOpener = /*#__PURE__*/function () {
  function EditorOpener(_editorService) {
    _classCallCheck(this, EditorOpener);

    this._editorService = _editorService;
  }

  _createClass(EditorOpener, [{
    key: "open",
    value: function open(target, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var selection, match;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (typeof target === 'string') {
                  target = URI.parse(target);
                }

                selection = undefined;
                match = /^L?(\d+)(?:,(\d+))?/.exec(target.fragment);

                if (match) {
                  // support file:///some/file.js#73,84
                  // support file:///some/file.js#L73
                  selection = {
                    startLineNumber: parseInt(match[1]),
                    startColumn: match[2] ? parseInt(match[2]) : 1
                  }; // remove fragment

                  target = target.with({
                    fragment: ''
                  });
                }

                if (target.scheme === Schemas.file) {
                  target = normalizePath(target); // workaround for non-normalized paths (https://github.com/Microsoft/vscode/issues/12954)
                }

                _context2.next = 7;
                return this._editorService.openCodeEditor({
                  resource: target,
                  options: {
                    selection: selection,
                    context: (options === null || options === void 0 ? void 0 : options.fromUserGesture) ? EditorOpenContext.USER : EditorOpenContext.API
                  }
                }, this._editorService.getFocusedCodeEditor(), options === null || options === void 0 ? void 0 : options.openToSide);

              case 7:
                return _context2.abrupt("return", true);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return EditorOpener;
}();

EditorOpener = __decorate([__param(0, ICodeEditorService)], EditorOpener);

var OpenerService = /*#__PURE__*/function () {
  function OpenerService(editorService, commandService) {
    var _this = this;

    _classCallCheck(this, OpenerService);

    this._openers = new LinkedList();
    this._validators = new LinkedList();
    this._resolvers = new LinkedList(); // Default external opener is going through window.open()

    this._externalOpener = {
      openExternal: function openExternal(href) {
        // ensure to open HTTP/HTTPS links into new windows
        // to not trigger a navigation. Any other link is
        // safe to be set as HREF to prevent a blank window
        // from opening.
        if (matchesScheme(href, Schemas.http) || matchesScheme(href, Schemas.https)) {
          dom.windowOpenNoOpener(href);
        } else {
          window.location.href = href;
        }

        return Promise.resolve(true);
      }
    }; // Default opener: maito, http(s), command, and catch-all-editors

    this._openers.push({
      open: function open(target, options) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!((options === null || options === void 0 ? void 0 : options.openExternal) || matchesScheme(target, Schemas.mailto) || matchesScheme(target, Schemas.http) || matchesScheme(target, Schemas.https))) {
                    _context3.next = 4;
                    break;
                  }

                  _context3.next = 3;
                  return this._doOpenExternal(target, options);

                case 3:
                  return _context3.abrupt("return", true);

                case 4:
                  return _context3.abrupt("return", false);

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
      }
    });

    this._openers.push(new CommandOpener(commandService));

    this._openers.push(new EditorOpener(editorService));
  }

  _createClass(OpenerService, [{
    key: "open",
    value: function open(target, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iterator, _step, validator, _iterator2, _step2, opener, handled;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // check with contributed validators
                _iterator = _createForOfIteratorHelper(this._validators.toArray());
                _context4.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context4.next = 11;
                  break;
                }

                validator = _step.value;
                _context4.next = 7;
                return validator.shouldOpen(target);

              case 7:
                if (_context4.sent) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", false);

              case 9:
                _context4.next = 3;
                break;

              case 11:
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](1);

                _iterator.e(_context4.t0);

              case 16:
                _context4.prev = 16;

                _iterator.f();

                return _context4.finish(16);

              case 19:
                // check with contributed openers
                _iterator2 = _createForOfIteratorHelper(this._openers.toArray());
                _context4.prev = 20;

                _iterator2.s();

              case 22:
                if ((_step2 = _iterator2.n()).done) {
                  _context4.next = 31;
                  break;
                }

                opener = _step2.value;
                _context4.next = 26;
                return opener.open(target, options);

              case 26:
                handled = _context4.sent;

                if (!handled) {
                  _context4.next = 29;
                  break;
                }

                return _context4.abrupt("return", true);

              case 29:
                _context4.next = 22;
                break;

              case 31:
                _context4.next = 36;
                break;

              case 33:
                _context4.prev = 33;
                _context4.t1 = _context4["catch"](20);

                _iterator2.e(_context4.t1);

              case 36:
                _context4.prev = 36;

                _iterator2.f();

                return _context4.finish(36);

              case 39:
                return _context4.abrupt("return", false);

              case 40:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 13, 16, 19], [20, 33, 36, 39]]);
      }));
    }
  }, {
    key: "resolveExternalUri",
    value: function resolveExternalUri(resource, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iterator3, _step3, resolver, result;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper(this._resolvers.toArray());
                _context5.prev = 1;

                _iterator3.s();

              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context5.next = 12;
                  break;
                }

                resolver = _step3.value;
                _context5.next = 7;
                return resolver.resolveExternalUri(resource, options);

              case 7:
                result = _context5.sent;

                if (!result) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", result);

              case 10:
                _context5.next = 3;
                break;

              case 12:
                _context5.next = 17;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](1);

                _iterator3.e(_context5.t0);

              case 17:
                _context5.prev = 17;

                _iterator3.f();

                return _context5.finish(17);

              case 20:
                return _context5.abrupt("return", {
                  resolved: resource,
                  dispose: function dispose() {}
                });

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 14, 17, 20]]);
      }));
    }
  }, {
    key: "_doOpenExternal",
    value: function _doOpenExternal(resource, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var uri, _yield$this$resolveEx, resolved;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                //todo@joh IExternalUriResolver should support `uri: URI | string`
                uri = typeof resource === 'string' ? URI.parse(resource) : resource;
                _context6.next = 3;
                return this.resolveExternalUri(uri, options);

              case 3:
                _yield$this$resolveEx = _context6.sent;
                resolved = _yield$this$resolveEx.resolved;

                if (!(typeof resource === 'string' && uri.toString() === resolved.toString())) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return", this._externalOpener.openExternal(resource));

              case 9:
                return _context6.abrupt("return", this._externalOpener.openExternal(encodeURI(resolved.toString(true))));

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._validators.clear();
    }
  }]);

  return OpenerService;
}();

OpenerService = __decorate([__param(0, ICodeEditorService), __param(1, ICommandService)], OpenerService);
export { OpenerService };